const TRANSFORMER_MAX_MOBILE_WIDTH_PX = 1023;
const TRANSFORMER_MIN_DESKTOP_WIDTH_PX = 1024;
export { TRANSFORMER_MAX_MOBILE_WIDTH_PX, TRANSFORMER_MIN_DESKTOP_WIDTH_PX };
